import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide004MyelinStoryScript() {
  return <KbGuidePage slug="guide-004-myelin-story-script" />;
}

(Guide004MyelinStoryScript as unknown as { path: string }).path = "/guides/myelin-story-script";
